import {reasonCodes} from './DeclineReasonPopover';

export const moveArrayElementToEnd = (
  arr: reasonCodes[],
  reasonText: string,
): reasonCodes[] => {
  const index = arr.findIndex(item => item.reasonDescription === reasonText);
  if (index !== -1) {
    const [element] = arr.splice(index, 1);
    if (element) arr.push(element);
  }
  return arr
    ?.slice()
    ?.sort((a, b) => a?.reasonTypeId.localeCompare(b?.reasonTypeId));
};
